import React from 'react'
import styled from 'styled-components'
import { Redirect } from 'react-router-dom'
import { withApollo } from 'react-apollo'
import { message, Typography, Row, Col } from 'antd'
import moment from 'moment';
import ConfirmUserA1 from '../../../components/user/ConfirmUserA1'
import { ErrorMessageFormAPI } from '../../../utils/checkError'
import SetPasswordsFirstTimeA1 from '../../../components/user/SetPasswordsFirstTimeA1'
import { setToken, isLoggedIn, getLsId, getOrganization, appVersion, versionWeb } from '../../../utils/auth'
import { Mutations, Queries } from '../../../graphql'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import OTPFrom from '../../../components/user/from/OTP'
import FooterLogin from '../../../components/user/FooterLogin'
import { sendToeventLog } from '../../../utils/eventLog'

const { Text, Title } = Typography
const BackgroundDiv = styled.div`
	// height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
`

const FormDiv = styled.div`
	padding: 50px 100px;
	box-shadow: 30px 40px 40px 1px rgba(0, 0, 0, 0.15), 0 0px 0px rgba(0, 0, 0, 0.25);
	border-radius 20px;
	background-color: #fff;
`

class Confirm extends React.PureComponent {
	state = {
		confirmpassword: false,
		verificationCode: "",
		citizenId: "",
		employeeCode: "",
		birthDate: "",
		firstName: "-",
		lastName: "-",
		positionName: "-",
		consent: true,
		policy: "",
		gender: "",
		consent: false,
		showModal: false,
		orgUnitName: "-",
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		showModalErrors: false
	}
	onSubmit = async values => {
		try {
			const { client } = this.props
			const { data, errors } = await client.query({
				query: Queries.verifyUser,
				variables: {
					verificationCode: values.verificationCode,
					citizenId: values.citizenId,
					lsid: getLsId(),
					birthDate: moment(values.birthDate).format('YYYY-MM-DD'),
					organization: getOrganization()
					// birthDate: "1987-02-14",
				}
			})
			// console.log("data : ",data);
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			// if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
			// 	await this.setState({
			// 		showModalErrors: true
			// 	})
			// }
			if (data.verifyUser) {
				await this.setState({
					firstName: data.verifyUser.firstName,
					lastName: data.verifyUser.lastName,
					gender: data.verifyUser.gender,
					orgUnitName: data.verifyUser.employee.workingProfile.orgUnit.orgUnitName,
					positionName: data.verifyUser.employee.workingProfile.orgPosition.positionName,
					verificationCode: values.verificationCode,
					citizenId: values.citizenId,
					lsid: getLsId(),
					birthDate: moment(values.birthDate).format('YYYY-MM-DD'),
					confirmpassword:true
				})

				let userId = null;
				let param = sessionStorage.getItem('username');
				let sourceDb = null;
				let path = '/verify';
				let action = 'ClickButton';
				sendToeventLog(userId, param, sourceDb, path, action);
				this.showModal()
			}
			else {
				// message.error("กรุณากรอกข้อมูลให้ถูกต้อง")
				// console.log("null");
			}


		} catch (error) {
			// console.log(error)
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(ErrorMessageFormAPI(errorMessage))
		}
	}

	fetchPolicyLastVersion = async () => {
		const { client } = this.props
		const { data, errors } = await client.query({
			query: Queries.fetchPolicyLastVersion,
		})
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
			await this.setState({
				showModalErrors: true
			})
		}
		await this.setState({
			policy: data.fetchPolicyLastVersion
		})
	}

	showModal() {
		this.setState({ showModal: true })
	}

	onSubmitSetPassword = async (value) => {
		const { verificationCode, citizenId, employeeCode, birthDate, policy } = this.state
		// console.log("value",value);
		
		try {
			const { client } = this.props

			// console.log('value.password',value);
			// console.log('value.confirmpassword',value.confirmpassword);

			const { data, errors } = await client.mutate({
				mutation: Mutations.requestVerifyOTPandSetupPassword,
				variables: {
					verificationCode: verificationCode,
					citizenId: citizenId,
					lsid: getLsId(),
					birthDate: birthDate,
					password: value.password,
					confirmPassword: value.confirmpassword,
					organization: getOrganization(),
					telNo: value.telNo,
					otp: value.otp
				}
			})
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			// if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
			// 	await this.setState({
			// 		showModalErrors: true
			// 	})
			// }
			// console.log(data.requestVerifyOTPandSetupPassword)
			if(data.requestVerifyOTPandSetupPassword.status){
				message.success('ยืนยันสำเร็จ')
				setTimeout(() => {
					localStorage.clear()
					window.location.href = '/'
				}, 1000);
			}
			
		} catch (error) {
			console.log(error)
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(errorMessage)
		}
	}

	handleOk = () => {
		this.setState({
			showModal: false,
			consent: true,
			confirmpassword: true
		});
	};

	handleCancel = () => {
		this.setState({ showModal: false });
	};

	componentDidMount() {
		this.fetchPolicyLastVersion()
	}

	render() {
		const { confirmpassword, firstName, lastName, positionName, gender, orgUnitName } = this.state
		if (isLoggedIn()) {
			return <Redirect to="/" />
		}

		return (
			<>
				<div style={{
					height: "100vh",
					backgroundImage: `url(${require("../../../assets/images/BGLogin.jpg")})`,
					backgroundPosition: 'center',
					// backgroundSize: 'cover',
					// backgroundRepeat: 'no-repeat'
				}}>
					<BackgroundDiv>
						<Row>
							<Col>
								<FormDiv className="p-5-moblie mt-5 formDiv">
									{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
									{
										this.state.showModalErrors &&
										<ModalErrors />
									}
									{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
									{confirmpassword &&
										<SetPasswordsFirstTimeA1
											autoFocus
											firstName={firstName}
											lastName={lastName}
											gender={gender}
											positionName={positionName}
											orgUnitName={orgUnitName}
											afterSubmit={this.onSubmitSetPassword}
										/>
										||
										<ConfirmUserA1
											autoFocus
											policy={this.state.policy}
											afterSubmit={this.onSubmit}
											handleOk={this.handleOk}
											handleCancel={this.handleCancel}
											showModal={this.state.showModal}
										/>
									}
								</FormDiv>
							</Col>
							<Col className="mt-4">
								<FooterLogin></FooterLogin>
							</Col>
						</Row>
					</BackgroundDiv>
				</div>
			</>
			
		)
	}
}

export default withApollo(Confirm)
